module.exports = __webpack_public_path__ + "img/Grupo 734.82df5eb1.svg";